export * from './adjustment.component';
